// ======================================================
//       receipts_header
// ======================================================

export const GET_RECEIPT_HEADER = "GET_RECEIPT_HEADER";
export const GET_RECEIPT_HEADER_UPDATE = "GET_RECEIPT_HEADER_UPDATE";
export const COPY_RECEIPT_HEADER = "COPY_RECEIPT_HEADER";


// ======================================================
//         receipts_lines
// ======================================================

export const GET_RECEIPT_LINES = "GET_RECEIPT_LINES";
export const GET_RECEIPT_LINES_UPDATE = "GET_RECEIPT_LINES_UPDATE";
export const COPY_RECEIPT_LINES = "COPY_RECEIPT_LINES";